import api from "./api";

export async function getDocuments() {
    const res = await api.get("admin/documents");
    return res.data.data;
}

export async function createDocument(payload) {
    const res = await api.post("admin/documents", payload);
    return res.data.data;
}

export async function updateDocument(id, payload) {
    const res = await api.put(`admin/documents/${id}`, payload);
    return res.data.data;
}

export async function deleteDocument(id) {
    const res = await api.delete(`admin/documents/${id}`);
    return res.data.data;
}